const win = window;
const debugEnabled =
    win.location.hash === "#debug" ||
    win.localStorage.debug === "true" ||
    document.documentElement.classList.contains("-backend");

export default debugEnabled;
